let isScrolling

export const scrollService = (e, callback) => {
  const bottom =
    e.target.scrollHeight - e.target.scrollTop ===
    e.target.clientHeight
  if (bottom && callback) {
    callback()
  }
}

export const scrollPercent = (e, callback) => {
  clearTimeout(isScrolling)
  const newEvent = { ...e }
  // Set a timeout to run after scrolling ends
  isScrolling = setTimeout(
    e => {
      const remaining = e.target.scrollHeight - e.target.clientHeight
      const finalPercent = (e.target.scrollTop / remaining) * 100
      // Run the callback
      if (callback) {
        callback(finalPercent)
      }
    },
    66,
    newEvent
  )
}

export default scrollService
